import { theme } from 'antd';
import { colors, borderRadius, typography } from './tokens';

export const lightTheme = {
  token: {
    colorPrimary: colors.primary,
    colorSuccess: colors.success,
    colorWarning: colors.warning,
    colorError: colors.error,
    colorInfo: colors.info,
    colorLink: colors.primary,
    colorLinkHover: colors.primaryHover,
    colorLinkActive: colors.primaryActive,
    colorBgContainer: colors.light.surface,
    colorBgElevated: colors.light.surface,
    colorBgLayout: colors.light.background,
    colorBgSpotlight: colors.light.text,
    colorText: colors.light.text,
    colorTextSecondary: colors.light.textSecondary,
    colorTextTertiary: colors.light.textTertiary,
    colorBorder: colors.light.border,
    colorBorderSecondary: colors.light.divider,
    borderRadius: borderRadius.md,
    fontFamily: typography.fontFamily,
    fontSize: typography.fontSizeBase,
    lineHeight: typography.lineHeight,
  },
  algorithm: theme.defaultAlgorithm,
};

export const darkTheme = {
  token: {
    colorPrimary: colors.primary,
    colorSuccess: colors.success,
    colorWarning: colors.warning,
    colorError: colors.error,
    colorInfo: colors.info,
    colorLink: colors.primaryLight,
    colorLinkHover: colors.primary,
    colorLinkActive: colors.primaryHover,
    colorBgContainer: colors.dark.surface,
    colorBgElevated: colors.dark.surfaceSecondary,
    colorBgLayout: colors.dark.background,
    colorBgSpotlight: colors.dark.surfaceTertiary,
    colorText: colors.dark.text,
    colorTextSecondary: colors.dark.textSecondary,
    colorTextTertiary: colors.dark.textTertiary,
    colorBorder: colors.dark.border,
    colorBorderSecondary: colors.dark.divider,
    borderRadius: borderRadius.md,
    fontFamily: typography.fontFamily,
    fontSize: typography.fontSizeBase,
    lineHeight: typography.lineHeight,
  },
  algorithm: theme.darkAlgorithm,
};

export const getTheme = (isDarkMode) => isDarkMode ? darkTheme : lightTheme;

const antdTheme = { lightTheme, darkTheme, getTheme };
export default antdTheme;
